import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// pipes
import { PriceFormatPipe } from './pipes/price.pipe';
import { AlphabeticSortPipe } from './pipes/alphabetic-sort.pipe';
import { ValueArrayFilterPipe } from './pipes/value-array-filter.pipe';

// services
import { CookiesService } from './services/cookies.service';
import { LocalStorageService } from './services/local-storage.service';
import { WindowRef } from './services/window-ref.service';
import { OfferApiService, SessionsApiService, LoginApiService, UserApiService, ValidationRulesApiService } from '@services/remote-api';
import { LoginService } from '@services/login.service';
import { GenericHttp } from './services/remote-api';
import { AuthGuard } from '@services/auth-guard.service';
import { AccountService } from './services/account.service';
import { NavigationService } from './services/navigation.service';

import { RoleGuard } from '@services/role-guard.service';
import { RoleDirective } from './directives/role.directive';
import { ContentEditableDirective } from './directives/contenteditable.directive';
import { BackgroundLoaderDirective } from './directives/background-loader.directive';
import { DownloadFileService } from '@services/download-file.service';
import { NumberFormatPipe } from './pipes/numbers.pipe';
import { TimePipe } from './pipes/time.pipe';
import { SanitizeHtmlPipe } from './pipes/safe-html.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule
  ],
  declarations: [
    PriceFormatPipe,
    SanitizeHtmlPipe,
    TimePipe,
    NumberFormatPipe,
    ValueArrayFilterPipe,
    AlphabeticSortPipe,
    RoleDirective,
    ContentEditableDirective,
    BackgroundLoaderDirective
  ],
  exports: [
    PriceFormatPipe,
    SanitizeHtmlPipe,
    TimePipe,
    RoleDirective,
    NumberFormatPipe,
    ContentEditableDirective,
    ValueArrayFilterPipe,
    BackgroundLoaderDirective
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AuthGuard,
        RoleGuard,
        PriceFormatPipe,
        CookiesService,
        LocalStorageService,
        WindowRef,
        GenericHttp,
        LoginApiService,
        ValidationRulesApiService,
        LoginService,
        SessionsApiService,
        OfferApiService,
        AccountService,
        UserApiService,
        NavigationService,
        DownloadFileService
      ]
    };
  }
}
